import React from "react";

const colorMap = {
  yellow: "border-yellow-600/40 bg-yellow-600/5",
  green: "border-green-600/40 bg-green-600/5",
  blue: "border-blue-600/40 bg-blue-600/5",
  red: "border-red-600/40 bg-red-600/5",
  orange: "border-orange-600/40 bg-orange-600/5",
  gray: "border-gray-600/40 bg-gray-600/5",
  purple: "border-purple-600/40 bg-purple-600/5",
};

const textColorMap = {
  yellow: "text-yellow-500",
  green: "text-green-500",
  blue: "text-blue-500",
  red: "text-red-500",
  orange: "text-orange-500",
  gray: "text-gray-400",
  purple: "text-purple-500",
};

export const AdminStatCard = ({ value, label, color = "yellow", icon, active, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`rounded-xl border p-4 cursor-pointer transition-all hover:scale-[1.02] ${
        active ? "ring-2 ring-yellow-500/50" : ""
      } ${colorMap[color] || colorMap.yellow}`}
      data-testid={`stat-card-${label?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className={`text-3xl font-bold ${textColorMap[color] || "text-yellow-500"}`}>{value}</p>
          <p className="text-gray-400 text-sm mt-1">{label}</p>
        </div>
        {icon && <div className="text-gray-600">{icon}</div>}
      </div>
    </div>
  );
};
